import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddOn_EntityFilter, Component_SearchAddOn } from '@nu-art/search';
import { SearchAddOn_ByTag } from './types.js';
import { LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './SearchAddOn_ByTag.scss';
import { ICONS } from '@app/styles';
import { exists, Filter, sortArray } from '@nu-art/ts-common';
import { ConfigKeyFE_SourceTagId, ModuleFE_Tag } from '../../../_entity.js';
import { TS_Icons } from '@nu-art/ts-styles';
export class Component_SearchAddOn_ByTag extends Component_SearchAddOn {
    addOn = SearchAddOn_ByTag;
    //######################### Life Cycle #########################
    __onTagsUpdated = (...params) => {
        const tags = ModuleFE_Tag.cache.filter(tag => !!tag.tagIds?.length);
        const labelMap = this.getTagLabelMap(tags);
        const adapter = this.getAdapter(tags, labelMap);
        this.setState({ tagLabelMap: labelMap, adapter });
    };
    __onSearchFilterChanged() {
        const nextValue = this.props.context.filter.get(this.addOn.key);
        this.setState({
            value: nextValue,
            show: this.calculateShouldShow(this.props)
        });
    }
    __onSyncStatusChanged = () => {
        this.reDeriveState({ adapter: undefined });
    };
    deriveStateFromProps(nextProps, state) {
        state.show ??= this.calculateShouldShow(nextProps);
        if (!state.adapter) {
            const tags = ModuleFE_Tag.cache.filter(tag => !!tag.tagIds?.length);
            state.tagLabelMap = this.getTagLabelMap(tags);
            state.adapter = this.getAdapter(tags, state.tagLabelMap);
        }
        return state;
    }
    //######################### Logic #########################
    getTagLabelMap(tags) {
        return tags.reduce((map, tag) => {
            map[tag._id] = this.getTagLabel(tag);
            return map;
        }, {});
    }
    getAdapter(tags, tagLabelMap) {
        const sourceId = ConfigKeyFE_SourceTagId.get();
        //Sort by final label
        sortArray(tags, tag => tagLabelMap[tag._id]);
        //Sort source tags to start
        sortArray(tags, tag => tag.tagIds[0] === sourceId ? -1 : 1);
        return SimpleListAdapter(tags, item => _jsx(_Fragment, { children: tagLabelMap[item.item._id] }));
    }
    calculateShouldShow(props) {
        const selectedEntities = props.context.filter.get(AddOn_EntityFilter.key);
        if (!selectedEntities?.length) {
            return true;
        }
        else {
            return props.context.getActiveSearchItems()
                .filter(item => selectedEntities.includes(item.module.dbDef.dbKey))
                .every(item => item.compatibleAddOnKeys.includes(SearchAddOn_ByTag.key));
        }
    }
    getTagLabel(tag) {
        if (!tag)
            return 'N/A';
        const parent = ModuleFE_Tag.cache.unique(tag.tagIds[0]);
        return `${parent?.label ?? 'N/A'}: ${tag.label}`;
    }
    onTagSelect = (tag, listType) => {
        const value = exists(this.state.value) ? { ...this.state.value } : { include: [], exclude: [] };
        value[listType].push({ parentId: tag.tagIds[0], childId: tag._id });
        this.setValue(value);
    };
    onTagRemove = (filter, list) => {
        const value = exists(this.state.value) ? { ...this.state.value } : { include: [], exclude: [] };
        value[list] = value[list]?.filter(i => i.childId !== filter.childId);
        this.setValue(value);
    };
    //######################### Render #########################
    render() {
        if (!this.state.show)
            return;
        return _jsx(TS_PropRenderer.Vertical, { label: this.render_Label, className: 'search-add-on__tag-filter', children: _jsxs(LL_V_L, { children: [this.render_Include(), this.render_Exclude()] }) });
    }
    render_Label = () => {
        return _jsxs(_Fragment, { children: ["By Tag", _jsx(TS_Icons.clear.component, { onClick: this.clear })] });
    };
    render_ListItem = (filter, onRemove) => {
        const tag = ModuleFE_Tag.cache.unique(filter.childId);
        return _jsxs(LL_H_C, { className: 'search-add-on__tag-filter__list-item', children: [this.getTagLabel(tag), _jsx(ICONS.x.component, { onClick: onRemove })] }, filter.childId);
    };
    render_Selector = (listType) => {
        const currentIds = this.state.value?.[listType].map(filter => filter.childId) ?? [];
        const filter = new Filter(item => [this.state.tagLabelMap[item._id]]);
        return _jsx(TS_DropDown, { adapter: this.state.adapter, selected: undefined, onSelected: tag => this.onTagSelect(tag, listType), queryFilter: item => !currentIds.includes(item._id), placeholder: 'Select a tag', filter: filter, limitItems: 30 });
    };
    render_Include = () => {
        const filters = this.state.value?.include;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Include', children: _jsxs(LL_H_C, { className: 'search-add-on__tag-filter__list', children: [filters?.map(filter => this.render_ListItem(filter, () => this.onTagRemove(filter, 'include'))), this.render_Selector('include')] }) });
    };
    render_Exclude = () => {
        const filters = this.state.value?.exclude;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Exclude', children: _jsxs(LL_H_C, { className: 'search-add-on__tag-filter__list', children: [filters?.map(filter => this.render_ListItem(filter, () => this.onTagRemove(filter, 'exclude'))), this.render_Selector('exclude')] }) });
    };
}
//# sourceMappingURL=SearchAddOn_ByTag.js.map